import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import CircularProgress from '@mui/material/CircularProgress';
import { SUB_PAGE_FOOTER_BACKGROUND_COLOR } from '../../styles/colors';
const CONTAINER_CSS = css `
  color: #aaaaaa;
  background-color: ${SUB_PAGE_FOOTER_BACKGROUND_COLOR};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 100;
  padding: 20px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
`;
export const SubPageLoadingSpinner = () => {
    return (_jsx("div", { css: CONTAINER_CSS, children: _jsx(CircularProgress, { color: 'inherit' }) }));
};
